import {
    AREA_DATA_FIELD,
    BAR_CHART,
    BUILDING_DATA_FIELD,
    COST_BY_STATUS_REPORT_TITLE,
    COST_DATA_FIELD,
    COUNT_FIELD,
    DEPLOYMENT_STATUS_FIELD,
    ROOM_DATA_FIELD,
    TOTAL_COST_FIELD,
    UPDATED_AT_DATA_FIELD
} from "../../constants/reports_constants";
import ReportGenerator from "./report_generator";

export default class CostByStatusReportGenerator extends ReportGenerator {

    _getGraphTitle() {
        return COST_BY_STATUS_REPORT_TITLE;
    }

    _hideUnusedColumns() {
        this._hideColumn(BUILDING_DATA_FIELD);
        this._hideColumn(COUNT_FIELD);
        this._hideColumn(ROOM_DATA_FIELD);
        this._hideColumn(TOTAL_COST_FIELD);
        this._hideColumn(UPDATED_AT_DATA_FIELD);
    }

    _showUsedColumns() {
        this._showColumn(AREA_DATA_FIELD);
        this._showColumn(COST_DATA_FIELD);
        this._showColumn(DEPLOYMENT_STATUS_FIELD);
    }

    _getChartType() {
        return BAR_CHART;
    }

    /**
     * Define filter function for this report
     * 
     * Cost by Status report only shows devices, not parts.
     * This filter is used by both table aggregator and chart generator.
     * 
     * @param {Array} items - Array of devices and/or parts
     * @returns {Array} Array containing only devices
     * @private
     */
    _filterItems(items) {
        return this._filterDevicesOnly(items);
    }
    
    /**
     * Override to provide filter function to chart generator
     *
     * Returns a predicate function (item => boolean) for use with Array.filter()
     * This filters to only include devices (items with device.device_type)
     *
     * @returns {Function} Predicate function that returns true for devices only
     * @protected
     */
    _getFilterFunction() {
        return (item) => item?.device?.device_type;
    }

    /**
     * Override to exclude parts from table
     * 
     * Uses the same filter function as the chart generator to ensure consistency.
     * 
     * @param {Array} devices - Array of devices and/or parts
     * @private
     */
    _tableAggregator(devices) {
        // Filter to include only devices (exclude parts)
        const devicesOnly = this._filterItems(devices);
        
        // Call parent implementation with filtered list
        super._tableAggregator(devicesOnly);
    }

}